import { clickBookAnyway, clickChangeInsurance } from '../../../Shared/Modals/addInsuranceModal/actions';

import {
    trackClickBookingSectionHeader,
    trackProcedureDropdownChange,
    trackProcedureDropdownClick,
    trackClickNewPatientType,
    trackClickExistingPatientType,
    trackKeyDownNewPatientType,
    trackKeyDownExistingPatientType,
} from './actions';

import {
    changeInsurance,
    changeProcedure,
    showMap,
    turnBookingSpotlightOff,
} from '../../actions';

export default {
    turnBookingSpotlightOff,
    showMap,
    changeInsurance,
    changeProcedure,
    clickBookAnyway,
    clickChangeInsurance,
    trackClickBookingSectionHeader,
    trackProcedureDropdownClick,
    trackProcedureDropdownChange,
    trackClickNewPatientType,
    trackClickExistingPatientType,
    trackKeyDownNewPatientType,
    trackKeyDownExistingPatientType,
};
